var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-table-simple",
        {
          staticStyle: { "table-layout": "fixed !important" },
          attrs: { bordered: "", striped: "", "sticky-header": _vm.maxHeight2 },
        },
        [
          _c(
            "b-thead",
            { attrs: { "head-variant": "dark" } },
            [
              _c(
                "b-tr",
                _vm._l(_vm.data_list_field, function (field) {
                  return _c("b-th", { key: field.key, style: field.thStyle }, [
                    _vm._v(_vm._s(field.label)),
                  ])
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tbody",
            _vm._l(_vm.data_list, function (data, index) {
              return _c(
                "b-tr",
                {
                  key: data.id,
                  class: index === _vm.dragIndex ? "dragging" : "",
                  attrs: { draggable: !_vm.edit_disabled },
                  on: {
                    dragstart: function ($event) {
                      return _vm.dragStart(index)
                    },
                    dragenter: function ($event) {
                      return _vm.dragEnter(index)
                    },
                    dragover: function ($event) {
                      $event.preventDefault()
                    },
                    dragend: _vm.dragEnd,
                  },
                },
                [
                  _vm._l(_vm.data_list_field, function (field) {
                    return [
                      field.key == "edit"
                        ? [
                            _c(
                              "b-td",
                              { key: field.id, style: field.thStyle },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "icon_btn",
                                    attrs: {
                                      variant: "info",
                                      disabled:
                                        _vm.edit_disabled || data.edit_disabled,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onEdit(data.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "pencil",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "b-td",
                              {
                                key: field.id,
                                class: field.tdClass,
                                style: field.thStyle,
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(data[field.key]) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                    ]
                  }),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }